import { NomenclatureCustomNameCreate, NomenclatureCustomNameItem } from "./types";
import { createActionTypes, createApiActions } from "../rootActions";
import { PayloadRequest } from "types/requestTypes";


export const fetchNomenclatureCustomNameDetail = createApiActions<PayloadRequest, NomenclatureCustomNameItem>(
    createActionTypes("NOMENCLATURE_CUSTOM_NAME_DETAIL")
);

export const fetchNomenclatureCustomNameEdit = createApiActions<PayloadRequest, void>(
    createActionTypes("NOMENCLATURE_CUSTOM_NAME_EDIT")
);

export const fetchNomenclatureCustomNameCreate = createApiActions<NomenclatureCustomNameCreate, void>(
    createActionTypes("NOMENCLATURE_CUSTOM_NAME_CREATE")
);

export const fetchNomenclatureCustomNameDelete = createApiActions<PayloadRequest, void>(
    createActionTypes("NOMENCLATURE_CUSTOM_NAME_DELETE")
);
